import { startBrowserApplication } from '@shared/runtime/browser-config';

void startBrowserApplication('casaweg', () => import('./renderApp'), import.meta.env.DEV);
